import React from 'react';
import { connect } from 'react-redux';
import { newUserGroupUrl, userGroupUrl } from '@/constants/urls';
import StandardToolsMenu from '@/components/tools/StandardToolsMenu';
import DropdownItem from '@/components/DropdownItem';
import { showDeleteUserGroupDialog } from '../actions/usergroups/delete';

const UserGroupTools = ({
  allowCreate,
  allowDelete,
  allowRead,
  listItem = false,
  newUserGroupCode,
  showDelete,
  upward,
  userGroup,
}) => (
  <StandardToolsMenu
    allowRead={allowRead}
    allowDelete={allowDelete}
    href={userGroupUrl(userGroup, '#')}
    upward={upward}
    listItem={listItem}
    onDelete={() => showDelete(userGroup)}
  >
    {allowCreate && (
      <DropdownItem icon="clone" textId="actions.duplicate" href={newUserGroupUrl(userGroup, newUserGroupCode, '#')} />
    )}
  </StandardToolsMenu>
);

const mapStateToProps = ({
  auth: { role: { permissions: { usergroups: { create, destroy, read } } } },
  userGroups: { newUserGroupCode },
}) => ({
  allowCreate: create,
  allowDelete: destroy,
  allowRead: read,
  newUserGroupCode,
});

const mapDispatchToProps = {
  showDelete: showDeleteUserGroupDialog,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserGroupTools);
